import React from "react";
import MaxContainer from "../../../components/Container/MaxContainer";

const UserAgreementPage = () => {
  const termsData = [
    {
      title: "1. Submission of Listings:",
      points: [
        "The Listing Providers shall ensure that all details contained in the property listing are accurate, current, and true.",
        "You confirm that you have all the legal authority to list property on our platform, either as the owner, agent, or authorized representative.",
        "Such completed listings should encompass detailed property description with its location, images, contact details, price, and any other relevant disclosures.",
      ],
    },
    {
      title: "2. Content Responsibility:",
      points: [
        "Listing Provider is solely responsible for all the content submitted on the site.",
        "We reserve the right to review, modify, or remove any listing which we find to be in any one of the following aspects: inaccurate, misleading, unlawful, inappropriate, or in contravention to this Agreement.",
        "You hereby grant us a non-exclusive, royalty-free, world license to display, distribute, and promote your listings for purposes of providing our services.",
      ],
    },
    {
      title: "3. Listing Moderation:",
      points: [
        "All Listings shall be moderated before publication.",
        "Listing does not guarantee approval by us.",
        "Listings violating any of our terms or having prohibited content such as false claims, harmful material, or unauthorized content will be deleted without notice.",
      ],
    },
    {
      title: "4. Listing Update:",
      points: [
        "You are expected to update any part or all of your property listing which becomes outdated or incorrect almost immediately.",
        "Removal or suspension of the listing may follow if information found in it is not kept up to date.",
      ],
    },
  ];

  const CopyrightTrademarkPolicy = [
    {
      title: "1. Ownership of Content:",
      points: [
        "All content (text, graphics, logos, images, software, trademarks, and the entire website) available on our website is owned either by the Savitarrealty or its content supplier.",
        "You are not allowed to copy, distribute, modify, or use any of the contents without prior written consent by Savitar Realty or Content Supplier.",
      ],
    },
    {
      title: "2. User Submissions:",
      points: [
        "When you submit listings, images, or other content, you represent and warrant that you own the rights to the submitted content or have obtained all necessary permissions.",
        "If you feel that your intellectual property rights have been violated, kindly inform us in writing with relevant evidence.",
      ],
    },
    {
      title: "3. Copyright Infringement Notice:",
      points: [
        "To file a copyright complaint, email us at [sales@savitarrealty.com] along with relevant details, such as ownership rights and infringing material.",
      ],
    },
  ];

  const LimitationLiability = [
    "As far as the law allows:",
    "We will not be responsible for any damages, losses, or injuries that result from the use of the website or the listings.",
    "There is no warranty of the accuracy or availability of any listing.",
    "In no case will this website, its owners or employees, affiliates, or agents be responsible for any incidental, consequential, direct, indirect, or punitivedamages related to your use of our platform.we disclaim any liability for any damnages, loss or harm happening due to your use of the website or from relying on listings.",
    "We remain non-attributable to any harm that comes from your website usage.",
    "You are aware and accept that all use of the website and the services is at your own risk",
  ];

  const ThirdPartyWebsites = [
    "We are not in any control of third party websites and hence, do not take accountability for its content, privacy practices or terms of use.",
    "Access linked sites at your own risk, and it is in your interest that you view the respective policies.",
  ];

  const DisclaimersWarranties = [
    {
      title: "1. Up to No Guarantee:",
      points: [
        "The website and its services are offered, as far as they are available, without warranties of any kind.",
        "We disclaim any warranties with respect to the reliability, suitability, availability, or safety of the website or the content.",
      ],
    },
    {
      title: "2. User Responsibilities:",
      points: [
        "Users will be solely responsible for verifying all the property detail available on this site and due diligence before agreeing.",
        "We shall not guarantee, promise, or otherwise hold out any property listed in this site or the agent or user to be endorsed as being of good quality.",
      ],
    },
  ];

  const termination = [
    "Violation of this Agreement or applicable laws;",
    "Submission of false, misleading, or unauthorized content;",
    "Engagement in fraudulent or unlawful activities; or",
    "Interference with the proper functioning of the website.",
    "In case of termination of this condition, all rights of usage thereby cease, and listings that are active may be removed.",
  ];

  const indemnification = [
    "Your use of the website or services",
    "Violation of this Agreement or applicable laws",
    "Inaccurate or unauthorized content submitted by you",
    "Any disputes or transactions involving property listings",
  ];

  const arbitration = [
    "You waive the right to institute any court proceedings with respect to any matter covered by this agreement, except as otherwise provided by law.",
    "The arbitration shall be final and binding.",
    "Each party shall incur its individual arbitration expenses unless directed otherwise by the arbitrator.",
  ];

  return (
    <MaxContainer>
      <div className="py-10">
        <div className="pb-4">
          <h1 className="text-center font-bold text-3xl">
            User Agreement for Savitar Realty
          </h1>
        </div>
        <div className="py-4 space-y-6">
          <h2 className="text-left font-bold text-2xl">Introductions</h2>
          <p className="font-normal text-lg text-black">
            Welcome to [savitarrealty.com] ("we," "our," "us" or "the website").
            User Agreement ("Agreement") is to govern your usage with our
            website and any services related to property listing, whether a
            property owner, agent, or perspective buyer/renter. Using the site
            implies acceptance of this Agreement, our Privacy Policy, and all
            applicable laws and regulations. If you disagree with any part of
            this Agreement, you are not allowed to use the website.
          </p>
          <p className="font-normal text-lg text-black">
            This Agreement applies to all visitors, users, and others
            (collectively referred to as "Users") accessing or using our
            platform for submitting, managing, browsing, or interacting with
            property listings
          </p>
        </div>
        <div className="py-4 space-y-6">
          <h2 className="text-left font-bold text-2xl">
            Submission and Administration of Listings
          </h2>
          <div>
            {termsData.map((term, index) => (
              <div key={index} className="mb-6">
                <h2 className="text-lg font-semibold text-gray-700 mb-2">
                  {term.title}
                </h2>
                <ul className="list-decimal list-inside text-gray-600 space-y-2 pl-4">
                  {term.points.map((point, i) => (
                    <li
                      className="list-inside list-lower-alpha text-lg font-normal"
                      key={i}
                    >
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="py-4 space-y-6">
          <h2 className="text-left font-bold text-2xl">
            Why We Collect Information From You
          </h2>
          <p className="font-normal text-lg text-black">
            To enhance the user experience and facilitate the management of
            property transactions, we might ask you for certain details of a
            personal or business nature. Such details may include:
          </p>
          <div>
            <ul className="list-decimal list-inside text-gray-600 space-y-2 pl-4">
              <li className="list-inside list-disc text-lg font-normal">
                Contact details such as name, email, phone number, and address
              </li>
              <li className="list-inside list-disc text-lg font-normal">
                Property-related details submitted in listings
              </li>
              <li className="list-inside list-disc text-lg font-normal">
                Browsing and search history-related behavioral data for website
                improvements
              </li>
              <li className="list-inside list-none text-lg font-semibold">
                There would be several reasons for collecting that information.
                They cover:
              </li>
              <li className="list-inside list-disc text-lg font-normal">
                Verification of authenticity for listings and users
              </li>
              <li className="list-inside list-disc text-lg font-normal">
                Facilitation of communication between a buyer/renter and the
                listing provider
              </li>
              <li className="list-inside list-disc text-lg font-normal">
                Personalization and improvement of our services
              </li>
              <li className="list-inside list-disc text-lg font-normal">
                Meeting legal and regulatory obligations
              </li>
              <li className="list-inside list-disc text-lg font-normal">
                Advertising, analytics, and promotional use (with user consent
                where applicable).
              </li>
              <li className="list-inside list-none text-lg font-semibold">
                Please refer to our Privacy Policy section below for details on
                how we use and protect your data.
              </li>
            </ul>
          </div>
        </div>
        <div className="py-4 space-y-6">
          <h2 className="text-left font-bold text-2xl">
            Copyright and Trademark Policy
          </h2>
          <div>
            {CopyrightTrademarkPolicy.map((item, index) => (
              <div key={index} className="mb-6">
                <h2 className="text-lg font-semibold text-gray-700 mb-2">
                  {item.title}
                </h2>
                <ul className="list-decimal list-inside text-gray-600 space-y-2 pl-4">
                  {item.points.map((point, i) => (
                    <li
                      className="list-inside list-lower-alpha text-lg font-normal"
                      key={i}
                    >
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="py-4 space-y-6">
          <h2 className="text-left font-bold text-2xl">
            Errors, Inaccuracies, and Omissions
          </h2>
          <p className="font-normal text-lg text-black">
            Although we make every effort to ensure accuracy, the website may
            contain typographical errors as well as inaccuracies or omissions
            with respect to listings, pricing, descriptions, or availability. We
            reserve the right to change such errors, inaccuracies, or omissions
            at any time without notice.
          </p>
          <div>
            <ul className="list-decimal list-inside text-gray-600 space-y-2 pl-4">
              <li className="list-inside list-disc text-lg font-normal">
                We make no representations with respect to the accuracy,
                reliability, or completeness of information on our platform.
              </li>
              <li className="list-inside list-disc text-lg font-normal">
                Users are encouraged to verify all information independently
                before making any decisions related to real estate properties.
              </li>
            </ul>
          </div>
        </div>
        <div className="py-4 space-y-6">
          <h2 className="text-left font-bold text-2xl">
            Limitation of Liability
          </h2>
          <p className="font-normal text-lg text-black">
            Although we make every effort to ensure accuracy, the website may
            contain typographical errors as well as inaccuracies or omissions
            with respect to listings, pricing, descriptions, or availability. We
            reserve the right to change such errors, inaccuracies, or omissions
            at any time without notice.
          </p>
          <div>
            <ul className="list-decimal list-inside text-gray-600 space-y-2 pl-4">
              {LimitationLiability.map((item: any, index: number) => (
                <li
                  className="list-inside list-disc text-lg font-normal first:list-none last:list-none"
                  key={index}
                >
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="py-4 space-y-6">
          <h2 className="text-left font-bold text-2xl">
            Links to Third-Party Websites
          </h2>
          <p className="font-normal text-lg text-black font-medium">
            Links to third-party websites may be made available on our website
            for ease or information purposes only. Their presence does not
            indicate any kind of endorsement or affiliation.
          </p>
          <div>
            <ul className="list-decimal list-inside text-gray-600 space-y-2 pl-4">
              {ThirdPartyWebsites.map((item: any, index: number) => (
                <li
                  className="list-inside list-disc text-lg font-normal"
                  key={index}
                >
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="py-4 space-y-6">
          <h2 className="text-left font-bold text-2xl">
            Disclaimers and Warranties
          </h2>
          <div>
            {DisclaimersWarranties.map((item, index) => (
              <div key={index} className="mb-6">
                <h2 className="text-lg font-semibold text-gray-700 mb-2">
                  {item.title}
                </h2>
                <ul className="list-decimal list-inside text-gray-600 space-y-2 pl-4">
                  {item.points.map((point, i) => (
                    <li
                      className="list-inside list-disc text-lg font-normal"
                      key={i}
                    >
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="py-4 space-y-6">
          <h2 className="text-left font-bold text-2xl">Termination</h2>
          <p className="text-lg text-black font-medium">
            We may suspend or terminate your access to the website, with or
            without notice, for any reason which may include, but is not limited
            to, the following:
          </p>
          <div>
            <ul className="list-decimal list-inside text-gray-600 space-y-2 pl-4">
              {termination.map((item: any, index: number) => (
                <li
                  className="list-inside list-disc text-lg font-normal last:list-none"
                  key={index}
                >
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="py-4 space-y-6">
          <h2 className="text-left font-bold text-2xl">Indemnification</h2>
          <p className="text-lg text-black font-medium">
            You agree to indemnify, defend, and hold harmless the website, its
            owners, employees, affiliates, and partners from any claims,
            damages, losses, liabilities, or expenses (including legal fees)
            arising from:
          </p>
          <div>
            <ul className="list-decimal list-inside text-gray-600 space-y-2 pl-4">
              {indemnification.map((item: any, index: number) => (
                <li
                  className="list-inside list-disc text-lg font-normal"
                  key={index}
                >
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="py-4 space-y-6">
          <h2 className="text-left font-bold text-2xl">Privacy Policy</h2>
          <p className="text-lg text-black font-normal">
            It is vital for you to be aware that your privacy is up to us. In
            fact, our Privacy Policy tells why and how we collect, use, share
            and protect personal data of individuals. Consent with this Privacy
            Policy means that when you use the site, you consent to our
            practices regarding data as described herein. For more assistance,
            please visit our [Privacy Policy] page.
          </p>
        </div>
        <div className="py-4 space-y-6">
          <h2 className="text-left font-bold text-2xl">Arbitration</h2>
          <p className="text-lg text-black font-medium">
            Disputes arising under this Agreement will be settled by binding
            arbitration, following the rules promulgated by [Arbitration
            Body/Agency], in [Jurisdiction/City]
          </p>
          <div>
            <ul className="list-decimal list-inside text-gray-600 space-y-2 pl-4">
              {arbitration.map((item: any, index: number) => (
                <li
                  className="list-inside list-disc text-lg font-normal"
                  key={index}
                >
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="py-4 space-y-6">
          <h2 className="text-left font-bold text-2xl">Governing Law</h2>
          <p className="text-lg text-black font-normal">
            It will be construed according to and governed by the laws of
            [State/Country], without regard to its principles of conflict of
            law.
          </p>
          <p className="text-lg text-black font-normal">
            Any disputes which arise under or relate to this Agreement shall
            fall under the sole jurisdiction of the courts located in [City,
            State]
          </p>
        </div>
        <div className="py-4 space-y-6">
          <h2 className="text-left font-bold text-2xl">Grievance</h2>
          <p className="text-lg text-black font-normal">
            You can let us know about your complaints, grievances, or concerns
            related to the website and its services by writing to us at Email:
            [sales@savitarrealty.com]. We strive to resolve all grievances in
            the earliest time possible period and following laws applicable.
          </p>
        </div>
        <div className="py-4 space-y-6">
          <h2 className="text-left font-bold text-2xl">Amendment</h2>
          <p className="text-lg text-black font-medium">
            We can amend our User Agreement anytime without notice. After
            posting on the website, changes to the terms and conditions will be
            effective immediately.
          </p>
          <div>
            <ul className="list-decimal list-inside text-gray-600 space-y-2 pl-4">
              <li className="list-inside list-disc text-lg font-normal">
                A continued use of the site after amendments signifies
                acceptance of the new Agreement.
              </li>
              <li className="list-inside list-disc text-lg font-normal">
                Users should check this Agreement periodically for changes.
              </li>
            </ul>
          </div>
        </div>
        <hr className="border-2 border-black/20 rounded" />
        <div className="py-2 px-3">
          <p className="text-lg text-black font-medium">
            By using [Savitarrealty.com], you profess that you have read this,
            that you understand it, and that you will live by this User
            Agreement. Otherwise, when you have not agreed with them you have to
            stop using this website
          </p>
        </div>
      </div>
    </MaxContainer>
  );
};

export default UserAgreementPage;
